export default __webpack_public_path__ + "static/Angular-e3e0978d6e66e8f59fc77e65aae25af1.webp";